import { render, staticRenderFns } from "./SolicitacoesTreinamentoEditar.vue?vue&type=template&id=234dff60"
import script from "./SolicitacoesTreinamentoEditar.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTreinamentoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports